import * as React from 'react';
import { useResolvedCompanyCtx } from '../../../contexts/ResolvedCompanyContext/ResolvedCompanyProvider';
import { isScopedKey } from '../config/persistedKeys'; // Because we have more apps & companies running on the same URL with the same storage
// the data would be shared and overridden.
// To prevent that, persistence keys can (should in most cases) be scoped to specific
// company (now it’s based on URL, so it’s the resolved company).

/**
 * Returns a function that scopes provided persistence key
 * to current resolved company.
 */

export var usePersistenceScope = function usePersistenceScope() {
  var _useResolvedCompanyCt = useResolvedCompanyCtx(),
      resolvedBranch = _useResolvedCompanyCt.resolvedBranch;

  var customScopeKey = resolvedBranch.name.trim().replace(/ /g, '-');
  var scopeKey = React.useCallback(function (key) {
    return isScopedKey(key) ? getScopedKey(key, customScopeKey) : key;
  }, [customScopeKey]);
  return scopeKey;
};
/**
 * Combines provided values into scoped persistence key.
 */

export var getScopedKey = function getScopedKey(key, baseRoute) {
  return "".concat(baseRoute, "-").concat(key);
};